import { useState, useEffect, useRef, useCallback } from "react";
import localStorageService from "../services/localStorageService";

function useLocalStorage(key, initialValue) {
  const [storedValue, setStoredValue] = useState(() => {
    const item = localStorageService.get(key);
    return item !== undefined ? item : initialValue;
  });
  const storedValueRef = useRef(storedValue);

  useEffect(() => {
    storedValueRef.current = storedValue;
  }, [storedValue]);

  useEffect(() => {
    localStorageService.set(key, storedValueRef.current);
  }, [key]);

  const setValue = useCallback(
    (value) => {
      setStoredValue((previousValue) => {
        const nextValue =
          value instanceof Function ? value(previousValue) : value;
        storedValueRef.current = nextValue;
        localStorageService.set(key, nextValue);
        return nextValue;
      });
    },
    [key],
  );

  return [storedValue, setValue];
}

export default useLocalStorage;
